import React, { useEffect, useId, useState } from 'react';
type Props = {
  variant?: 'light' | 'dark';
  title?: string;
};
const JOTFORM_SRC = 'https://form.jotform.com/261894703462059';
export function InquiryForm({
  variant = 'light',
  title = 'Connect with a Senior Living Specialist'
}: Props) {
  const isDark = variant === 'dark';
  const reactId = useId().replace(/[:]/g, '');
  const iframeId = `JotFormIFrame-${reactId}`;

  // The JotForm content is taller on narrow screens (fields stack and labels
  // wrap), so a single fixed height crops the bottom (the submit button) on
  // mobile. We pick a height once per breakpoint from the viewport width on
  // mount and on resize. This changes only when the breakpoint changes — not
  // continuously like the JotForm auto-resize handler — so there is no jitter.
  const [iframeHeight, setIframeHeight] = useState(670);
  useEffect(() => {
    const measure = () => {
      const w = window.innerWidth;
      if (w < 400) setIframeHeight(940);else if (w < 640) setIframeHeight(880);else setIframeHeight(670);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);
  return <div className={`overflow-hidden rounded-md p-5 sm:p-6 ${isDark ? 'bg-forest-dark' : 'bg-white shadow-xl ring-1 ring-sand'}`} data-id="element-86" data-mp="nxvzwt1w1ooy">
      <h3 className={`font-display text-2xl leading-snug sm:text-[27px] ${isDark ? 'text-white' : 'text-forest'}`} data-id="element-87" data-mp="j5l1xvqpkcz1">
        {title}
      </h3>
      <div className="mt-2 h-0.5 w-14 bg-gold" data-id="element-88" data-mp="sxgzn5ovu12q" />

      <div className="mt-2 w-full overflow-hidden" data-id="element-89" data-mp="sys12yuuuwqo">
        {/*
          Fixed (per-breakpoint) height + scrolling disabled and NO auto-resize
          embed handler. The JotForm embed handler continuously re-measures and
          re-sets the iframe height, which made the bottom of the form jitter.
          A stable height sized to the (compacted) form removes the jitter,
          while the breakpoint-based height above keeps the full form visible on
          mobile where the content is taller.
           The gap between our heading and the form's first field is JotForm's
          own built-in top padding, which lives inside the iframe and can't be
          edited. A negative top margin pulls the iframe up so that built-in
          padding tucks under the heading, closing the visible gap. The parent
          uses overflow-hidden so nothing spills above.
         */}
        <iframe id={iframeId} title="Connect with a Senior Living Specialist" allow="geolocation; microphone; camera; fullscreen; payment" src={JOTFORM_SRC} frameBorder={0} scrolling="no" style={{
        display: 'block',
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
        height: iframeHeight,
        marginTop: -20,
        border: 'none'
      }} data-id="element-90" data-mp="1qk7xfg2vnqgc" />
      </div>
    </div>;
}